import React from "react";
import { useParams } from "react-router-dom";
import { Select, SelectItem, Input, Spinner, Button, Card, CardBody } from "@nextui-org/react";
import styles from "./RegistroPersona.css";

const RegistroPersona = ({ 
  formData = {}, 
  errors = {}, 
  handleChange, 
  handleBlur, 
  handleSubmit,
  isSubmitting,
  validateCaptcha = true, // Por defecto true si no hay captcha activo
  formConfig = [] 
}) => {
  
  // Extraemos el slug para asociar el registro a la URL del cliente
  const { slug } = useParams();

  const onFormSubmit = (e) => {
    e.preventDefault();
    // Enviamos los datos junto con el slug a la API de PHP
    handleSubmit(formData, slug);
  };

  return (
    <Card className="max-w-[500px] mx-auto my-10 shadow-none border-none bg-transparent">
      <CardBody>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ fontWeight: '700', fontSize: '26px', color: '#111' }}>Registro de Persona</h2>
          <p style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
            Completa tus datos para el perfil de <strong>{slug}</strong>
          </p>
        </div>

        <form onSubmit={onFormSubmit} className="flex flex-col gap-6">
          {formConfig.map((field) => (
            <div key={field.name}>
              {field.type === "select" ? (
                <Select
                  label={field.label}
                  isRequired={field.isRequired}
                  placeholder={`Selecciona ${field.label.toLowerCase()}`}
                  selectedKeys={formData[field.name] ? [formData[field.name]] : []}
                  variant="bordered"
                  radius="sm"
                  onSelectionChange={(keys) => handleChange(Array.from(keys)[0], field.name)}
                  isInvalid={!!errors[field.name]}
                  errorMessage={errors[field.name]}
                  classNames={{ label: "text-black/50", trigger: "border-1" }}
                >
                  {(field.options || []).map((opt) => (
                    <SelectItem key={opt.id} value={opt.id}>
                      {opt.description}
                    </SelectItem>
                  ))}
                </Select>
              ) : (
                <Input
                  label={field.label}
                  isRequired={field.isRequired}
                  type={field.type || "text"}
                  placeholder={`Escribe tu ${field.label.toLowerCase()}`}
                  value={formData[field.name] || ""}
                  variant="bordered"
                  radius="sm"
                  onValueChange={(val) => handleChange(val, field.name)}
                  onBlur={() => handleBlur(field.name)}
                  isInvalid={!!errors[field.name]}
                  errorMessage={errors[field.name]}
                  classNames={{ label: "text-black/50", inputWrapper: "border-1" }}
                />
              )}
            </div>
          ))}

          {/* Sección de Términos y Condiciones */}
          <div className="flex flex-col gap-2 mt-2">
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                id="terminos"
                checked={formData.terminos || false}
                onChange={(e) => handleChange(e.target.checked, "terminos")}
                className="mt-1 h-4 w-4 rounded border-gray-300 accent-black"
              />
              <label htmlFor="terminos" className="text-xs leading-relaxed text-gray-600">
                Autorizo y acepto el tratamiento de mis datos personales según los{" "}
                <a 
                  href="https://www.ragged.com.co/aviso-para-el-tratamiento-de-datos-personales" 
                  target="_blank" 
                  rel="noreferrer"
                  className="underline font-semibold text-black"
                >
                  Términos y Condiciones
                </a>.
              </label>
            </div>
            {errors.terminos && (
              <span className="text-tiny text-danger">{errors.terminos}</span>
            )}
          </div>

          {/* Botón de envío minimalista */}
          <Button
            type="submit"
            color="primary"
            radius="sm"
            size="lg"
            className="font-bold mt-4 bg-black text-white"
            isDisabled={isSubmitting || !validateCaptcha || !formData.terminos}
            isLoading={isSubmitting}
            spinner={<Spinner size="sm" color="white" />}
          >
            {isSubmitting ? "PROCESANDO..." : "REGISTRAR"}
          </Button>
        </form>
      </CardBody>
    </Card>
  );
};

export default RegistroPersona;